import React, { FC, forwardRef } from 'react';
import Link from 'next/link';
import styled from 'styled-components';
import {
  Box,
  defaultColors,
  IconSize,
  LinkButton,
  LinkButtonType,
  OParagraph,
  OTitle,
  Tooltip,
} from '@lifechurch/react-ion';
import { SpaceProps } from 'styled-system';
import { LogicalProps } from '@lifechurch/react-ion/logical';

interface Props extends SpaceProps, LogicalProps {
  title: string;
  breadcrumb?: string;
  breadcrumbHref?: string;
  breadcrumbs?: Array<string>;
  breadcrumbsHrefs?: Array<string>;
  tooltipContent?: string;
}

const StyledLinkButton = styled(LinkButton)`
  position: relative;
`;

const BreadcrumbSpacer: FC = () => (
  <>
    {' '}
    <OParagraph display='inline-flex' color={defaultColors.gray50}>
      /
    </OParagraph>{' '}
  </>
);

export const PageHeader = forwardRef<HTMLHeadingElement, Props>(
  (
    {
      title,
      breadcrumb,
      breadcrumbHref,
      breadcrumbs = [],
      breadcrumbsHrefs = [],
      tooltipContent,
      ...spaceProps
    },
    ref
  ) => {
    const hasBreadcrumbs =
      breadcrumbs?.length > 0 &&
      breadcrumbsHrefs?.length > 0 &&
      breadcrumbs?.length === breadcrumbsHrefs?.length;

    return (
      <Box marginBlockEnd={7} {...spaceProps}>
        {breadcrumb && breadcrumbHref && (
          <Link href={breadcrumbHref}>
            <StyledLinkButton buttonType={LinkButtonType.SECONDARY}>{breadcrumb}</StyledLinkButton>
          </Link>
        )}
        {hasBreadcrumbs &&
          breadcrumbs?.map((breadcrumb: string, index) => (
            <React.Fragment key={breadcrumb}>
              {index !== 0 && <BreadcrumbSpacer />}
              <Link href={breadcrumbsHrefs[index]}>
                <StyledLinkButton buttonType={LinkButtonType.SECONDARY}>
                  {breadcrumb}
                </StyledLinkButton>
              </Link>
            </React.Fragment>
          ))}
        <OTitle ref={ref}>
          {title}
          {tooltipContent && (
            <Box display='inline-block' marginInlineStart={2}>
              <Tooltip content={tooltipContent} size={IconSize.LG} />
            </Box>
          )}
        </OTitle>
      </Box>
    );
  }
);

PageHeader.displayName = 'ForwardRef(PageHeader)';
